var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('a',{staticClass:"back-to-top fixed flex justify-center items-center rounded bg-blue w-8 h-8",attrs:{"href":"#","aria-label":_vm.buttonAriaLabel}},[_c('span',{staticClass:"Picto_arrow-up2"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }